import _ from 'underscore';

export default (() => {

    function getAuthorizationHeader(sessionToken) {

        return 'Bearer ' + sessionToken || '';
    }

    function jsonToFormData(formData, data, parentKey) {

        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
            Object.keys(data).forEach(key => {
                jsonToFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
            });
        } else {
            if(data !== undefined && data !== null) {
                formData.append(parentKey, data);
            }
        }
    }

    return {
        getAuthorizationHeader,
        jsonToFormData
    };

})();


// WEBPACK FOOTER //
// ./services/requestFormatter.js